import React from 'react';
import { MessageCircle } from 'lucide-react';
import { CONTACT } from '../mock/data';

export default function FloatingWhatsApp() {
  return (
    <a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact us on WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 group"
    >
      <span className="hidden md:block bg-ink text-cream text-xs tracking-wider uppercase px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Chat with us
      </span>
      <span className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg shadow-black/20 hover:scale-110 transition-transform duration-300">
        <MessageCircle size={26} className="text-white" />
      </span>
    </a>
  );
}
